import ArticleInformation from "../../types/ArticleInformation"

export const addArticleInformationParam = (articleInfo : ArticleInformation) => {
    return {
      type: 'AddArticleParam',
      payload: articleInfo,
    }
  }
  
  export const deleteArticleInformationParam = () => {
    return {
      type: 'DeleteArticleParam'
    }
  }